import { render, staticRenderFns } from "./NewCustomButton.vue?vue&type=template&id=c613166e"
import script from "./NewCustomButton.vue?vue&type=script&lang=ts"
export * from "./NewCustomButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c613166e')) {
      api.createRecord('c613166e', component.options)
    } else {
      api.reload('c613166e', component.options)
    }
    module.hot.accept("./NewCustomButton.vue?vue&type=template&id=c613166e", function () {
      api.rerender('c613166e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/NewCustomButton.vue"
export default component.exports